import ActualRevenuePanel from 'components/ActualCommissionRevenuePanel/ActualCommissionRevenuePanel';
import ActualRevenue from 'components/ActualCommissionRevenue/ActualCommissionRevenue';
// import FillRateMapModal from 'components/FillRateMapModal/FillRateMapModal';

import React, { Component } from 'react'
import { Grid, Container, Segment } from 'semantic-ui-react';
import './ActualCommissionRevenueContainer.less';

const OPEN_ACTUAL_REVENUE = "OPEN_ACTUAL_REVENUE"


const initialStates = {
    openedPanel: undefined,
    fillRateFilterDataToShow: '',
    subscriptionRevenueFilterDataToShow: '',
    commissionRevenueFilterDataToShow: "",
    actualRevenueFilterDataToShow: "",
    fillRatesLastDays: 0,
    commissionRevenueLastMonths: 30,
    actualRevenueLastMonths: 30,
    refreshFillRateData: 0,
    fillRateMapDataToShow: "",
    fillRateMapDataModalIsOpen: false,
    fillRateSelectedFilters: { market: {}, category: {} }
}

class ActualCommissionRevenueContainer extends Component {
    constructor(props) {
        super(props);
        this.state = initialStates;
    }

    openPanelHandler = (panelName) => {
        this.setState({ openedPanel: panelName })
    }
    actualRevenueFilterDataToShowHandler = (filterType) => {
        this.setState({
            actualRevenueFilterDataToShow: filterType, commissionRevenueFilterDataToShow: "", subscriptionRevenueFilterDataToShow: "", fillRateFilterDataToShow: ""
        })
    }
    actualRevenueLastMonthsHandler = (value) => {
        this.setState({ actualRevenueLastMonths: value })
    }
    // handleFillRateMapModalClose = () => {
    //     this.setState({ fillRateMapDataModalIsOpen: false })
    // }

    render() {
        return (
            <Container fluid className={"dashboard-container"}>
                <Segment>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <ActualRevenue filterDataToShowHandler={this.actualRevenueFilterDataToShowHandler} filterDataToShow={this.state.actualRevenueFilterDataToShow} openPanel={() => { this.openPanelHandler(OPEN_ACTUAL_REVENUE) }} lastMonths={this.state.actualRevenueLastMonths} actualRevenueLastMonthsHandler={this.actualRevenueLastMonthsHandler} ></ActualRevenue>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                {
                                    this.state.openedPanel == OPEN_ACTUAL_REVENUE
                                    &&
                                    <div>
                                        <ActualRevenuePanel lastMonths={this.state.actualRevenueLastMonths} key={"ar-panel-key"} filterDataToShow={this.state.actualRevenueFilterDataToShow}></ActualRevenuePanel>
                                    </div>
                                }
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Container>
        )
    }
}

export default ActualCommissionRevenueContainer
